import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var NavigationPointerOff02 = function NavigationPointerOff02(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "m10.4712 5.4758.7919-1.8054c.2316-.528.3474-.792.5093-.8729a.5.5 0 0 1 .4466 0c.1619.0808.2777.3449.5093.873l3.1723 7.2328m-6.954-1.9518L3.9817 20.272c-.2566.585-.3849.8775-.3282 1.0568a.5.5 0 0 0 .3266.3261c.1794.0565.4717-.0721 1.0564-.3293l6.637-2.9203c.1187-.0522.178-.0783.2397-.0887a.5.5 0 0 1 .165 0c.0616.0104.121.0365.2397.0887l6.6369 2.9203c.5847.2572.8771.3858 1.0565.3293a.5.5 0 0 0 .3265-.3261c.0567-.1793-.0716-.4718-.3281-1.0568l-.2042-.4654M22 22 2 2"
    })
  }));
};
export default NavigationPointerOff02;